import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-full-status-led',
  templateUrl: './full-status-led.component.html',
  styleUrls: ['./full-status-led.component.scss'],
})
export class FullStatusLedComponent implements OnInit, OnChanges {
  @Input()
  full!: boolean;

  label = '';
  color!: string;
  size = 4;
  radius = 4;

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      this.translate.get(['TOTALS.FACILITY_OPEN', 'TOTALS.FACILITY_FULL']).subscribe((d) => {
        if (this.full) {
          this.label = d['TOTALS.FACILITY_FULL'];
          this.color = 'rgba(181,29,14,1.0)';
        } else {
          this.label = d['TOTALS.FACILITY_OPEN'];
          this.color = 'rgba(12,206,107,1.0)';
        }
      });
    }
  }
}
